import React from 'react';
export function AnnouncementBar() {
  return <a href="#booking" className="block border-b border-[#D4AF37]/20 bg-[#D4AF37]/10 px-5 py-2.5 text-center text-[11px] font-medium text-[#F4D9A0] transition-colors duration-150 ease-out hover:bg-[#D4AF37]/15 sm:text-xs" data-id="element-1348" data-mp="9h282vybyv0p">
      Founding Membership is now open, limited first cohort.{' '}
      <span className="underline underline-offset-2" data-id="element-1349" data-mp="30hve07pu54hd">Book your call</span>
    </a>;
}